import React from "react";
import { motion } from "framer-motion";

const RINGS = [0.25, 0.5, 0.75, 1];

function scoreColor(s) {
  if (s >= 90) return "#2DD4BF";
  if (s >= 80) return "#06B6D4";
  if (s >= 70) return "#3B82F6";
  return "#F59E0B";
}

export default function CandidateRadar({ applicants, onSelect, selectedId }) {
  return (
    <div data-testid="candidate-radar-canvas"
      className="relative w-full aspect-square max-w-[520px] mx-auto rounded-full border border-cyan-500/20 bg-slate-950/60 shadow-[0_0_60px_rgba(6,182,212,0.15)] overflow-hidden">
      {RINGS.map((r, i) => (
        <div key={i} className="radar-ring" style={{ width: `${r * 92}%`, height: `${r * 92}%` }}>
          <span className="absolute top-1 left-1/2 -translate-x-1/2 text-[10px] font-mono text-cyan-500/50">{Math.round(100 - r * 100)}%</span>
        </div>
      ))}
      <div className="absolute top-1/2 left-0 w-full h-px bg-cyan-500/10" />
      <div className="absolute left-1/2 top-0 h-full w-px bg-cyan-500/10" />
      <div className="radar-sweep" />

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
        <div className="w-3 h-3 rounded-full bg-teal-400 blip" />
        <span className="absolute top-4 left-1/2 -translate-x-1/2 text-[10px] font-mono text-teal-400 whitespace-nowrap">BEST FIT</span>
      </div>

      {applicants.map((a) => {
        const score = a.match_score || 75;
        const frac = ((100 - score) / 100) * 44;
        const rad = ((a.bearing || 0) * Math.PI) / 180;
        const x = 50 + frac * Math.sin(rad);
        const y = 50 - frac * Math.cos(rad);
        const color = scoreColor(score);
        const active = selectedId === a.id;
        return (
          <motion.button key={a.id} data-testid="candidate-blip-item"
            initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: Math.random() * 0.5, type: "spring", stiffness: 200 }}
            onClick={() => onSelect(a)}
            className="group absolute -translate-x-1/2 -translate-y-1/2 z-20"
            style={{ left: `${x}%`, top: `${y}%` }}>
            <span className={`block rounded-full transition-all ${active ? "w-4 h-4 ring-2 ring-white" : "w-3 h-3 group-hover:w-4 group-hover:h-4"}`}
              style={{ background: color, boxShadow: `0 0 10px ${color}` }} />
            <span className="absolute left-1/2 -translate-x-1/2 top-4 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-30 glass rounded-lg px-2.5 py-1.5 text-left">
              <span className="block text-[11px] font-semibold text-slate-100">{a.applicant?.name}</span>
              <span className="block text-[10px] font-mono text-teal-400">{score}% match · {a.job_title}</span>
            </span>
          </motion.button>
        );
      })}
    </div>
  );
}
